import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/styles';
import { useMediaQuery, AppBar, Toolbar } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';

import { Sidebar, Footer, Rightbar } from './components';
import AcUnitIcon from '@material-ui/icons/AcUnit';
import MenuIcon from '@material-ui/icons/Menu';
import GDPR from '../../components/GDPR';

import './css/style.css'

import { LOGO_ONLY as theLogo } from '../../constants';

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    //paddingTop: 56,
    // height: '100%',
    minHeight: '90vh',

  },
  appBar: {
    // minHeight: 160,
    background: 'white',
    display: 'block'
},
toolBarCenter: {
    width: 'fit-content',
    margin: 'auto',
},
  shiftContent: {
    paddingLeft: 75
  },
  content: {
    // height: '100%',
    minHeight: '90vh'
  },
  body: {
    background: '#fff'
  }

}));

const User = props => {
  const { children, user } = props;

  const classes = useStyles();
  const theme = useTheme();
  const isDesktop = false; // useMediaQuery(theme.breakpoints.up('lg'), {
//     defaultMatches: true
//   });

  const [openSidebar, setOpenSidebar] = useState(false);


  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const shouldOpenSidebar = openSidebar;

//   return (
//     <div
//       id="main-layout"
//       className={clsx({
//         [classes.root]: true,
//         [classes.shiftContent]: isDesktop
    
//       })}
//     >
//           <Fab color="primary" aria-label="add" className={classes.menu} 
//            onClick={handleSidebarOpen}
//           >
//                <IconButton  onClick={handleSidebarOpen}
//                     // edge="start" 
//                     className={classes.menuButton} 
//                     color="inherit" 
//                     aria-label="menu">
//                       <MenuIcon />
//                   </IconButton> 
//               {/* <AcUnitIcon
//         onClick={handleSidebarOpen}
//       /> */}

//           </Fab>
     
//       <Sidebar
//         onClose={handleSidebarClose}
//         open={shouldOpenSidebar} 
//         user={user}
//       />

//       <main className={classes.content}>
//         {children}
//       </main>
//       <Footer />

     

//     </div>
//   );
    return (
        <div
            id="main-layout"
            className={clsx({
                [classes.root]: true,
            })}
        >
       
            <AppBar color="default" className={classes.appBar} >
                <Toolbar className={classes.toolBarCenter}>
                    <a href='/'>
                        <img src={theLogo} alt="Understanding Ag, LLC" className='company-logo' width='150' />
                    </a>
                    <div style={{marginTop: 30, color: '#623b17', marginLeft: 2, fontSize: 18, fontWeight: 500}}>
                    Understanding<span style={{fontWeight: 'bold'}}>AG</span>&nbsp;&nbsp;Regen Ag Online Series
                    </div>

                </Toolbar>
            </AppBar>
            <Fab color="primary" aria-label="add" className={'fabMenu'}
                onClick={handleSidebarOpen}
            >
                <IconButton onClick={handleSidebarOpen}
                    // edge="start" 
                    className={classes.menuButton}
                    color="inherit"
                    aria-label="menu">
                    <MenuIcon />
                </IconButton>
            </Fab>

            <Sidebar
                onClose={handleSidebarClose}
                open={shouldOpenSidebar}
                user={user}
            />
            <main className={classes.content}>
                {children}

            </main>
            <GDPR />
            <Footer />
        </div>
    );
};

User.propTypes = {
  children: PropTypes.node,
  user: PropTypes.object
};

export default User;
